if (!customElements.get("tab-button")) {
  class TabButton extends HTMLElement {
    constructor() {
      super();
      this.changeActiveTab = this.changeActiveTab.bind(this);
    }

    changeActiveTab() {
      const targetId = this.getAttribute("data-panel");
      if (!targetId) {
        console.error("No data-panel attribute found on tab-button.");
        return;
      }

      const targetElement = document.querySelector(`#${targetId}`);
      if (!targetElement) {
        console.error(`Target element with ID "${targetId}" not found.`);
        return;
      }

      // Deactivate all tab buttons and panels
      document.querySelectorAll("tab-button").forEach((btn) => {
        btn.classList.remove("active");
        btn.setAttribute("aria-selected", "false");
      });

      document.querySelectorAll(".tab-panel").forEach((panel) => {
        panel.classList.remove("active");
      });

      // Activate current tab button and panel
      this.classList.add("active");
      this.setAttribute("aria-selected", "true");
      targetElement.classList.add("active");
    }

    connectedCallback() {
      this.addEventListener("click", this.changeActiveTab);
    }
  }
  customElements.define("tab-button", TabButton);
}
